import React from "react";
import { FormField } from "../../UI/DesignStandards";
import SquadSelect from "../../ScoringHub/ScoringToolbar/SquadSelect";
import { squadPickerLabel } from "../../ScoringHub/ScoringToolbar/scoringFilterOptions";

const eventLabel = (event) =>
  event
    ? `${event.eventName} (${event.bowlerQuantity} bowler${
        event.bowlerQuantity !== 1 ? "s" : ""
      })`
    : "Not chosen";

export const ContextHeader = ({
  selectedEvent,
  selectedSquad,
  onEventChange,
  onSquadChange,
  events,
  squads,
  errors = {},
  locked = false,
}) => {
  if (locked) {
    return (
      <div className="space-y-4">
        <h3 className="heading-display text-lg">Squad & Event</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
          <div>
            <p className="font-medium text-brand-muted mb-1">Squad</p>
            <p className="text-brand-charcoal">
              {selectedSquad ? squadPickerLabel(selectedSquad) : "Not chosen"}
            </p>
          </div>
          <div>
            <p className="font-medium text-brand-muted mb-1">Event</p>
            <p className="text-brand-charcoal">{eventLabel(selectedEvent)}</p>
          </div>
        </div>
      </div>
    );
  }

  const showEventSelect = Boolean(selectedSquad) && events.length > 1;

  return (
    <div className="space-y-4">
      <h3 className="heading-display text-lg">Squad & Event</h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <SquadSelect
          label="Squad"
          squads={squads}
          value={selectedSquad?.id || ""}
          onChange={onSquadChange}
          required
          error={errors.squad}
          className="mb-0"
        />

        {showEventSelect ? (
          <FormField
            label="Event"
            type="select"
            value={selectedEvent?.id || ""}
            onChange={(e) => onEventChange(e.target.value)}
            error={errors.event}
            required
            className="mb-0"
          >
            <option value="">Select an event</option>
            {events.map((event) => (
              <option key={event.id} value={event.id}>
                {eventLabel(event)}
              </option>
            ))}
          </FormField>
        ) : (
          <div>
            <p className="font-medium text-brand-muted mb-1">Event</p>
            <p className="text-sm text-brand-charcoal">
              {selectedSquad
                ? selectedEvent
                  ? eventLabel(selectedEvent)
                  : "No events on this squad"
                : "Choose a squad first"}
            </p>
            {errors.event ? (
              <p className="text-sm text-red-600 mt-1">{errors.event}</p>
            ) : null}
          </div>
        )}
      </div>
    </div>
  );
};
